import Analytics from 'helpers/analytics';
import { useRef, useEffect } from 'react';
import { ContextLog } from 'constants/contextLog';

interface AnalyticsOpenScreenHook {
	context: ContextLog;
	trackName: string;
	analyticProps?: any;
}

export const useAnalyticsOpenScreen = ({
	context,
	trackName,
	analyticProps,
}: AnalyticsOpenScreenHook) => {
	const refAnalyticsTimeOut = useRef<any>(null);

	useEffect(() => {
		refAnalyticsTimeOut.current = setTimeout(() => {
			Analytics.track(context, trackName, analyticProps);
		});

		return () => clearTimeout(refAnalyticsTimeOut.current);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
